import { IEquatable } from "./ModelPath/IEquatable";
import { getSimpleHashByString } from "./hashUtils";

export class StringArrayKey implements IEquatable<StringArrayKey> {
    public readonly items: string[];
    private cachedHash: number | undefined;

    public constructor(items: string[]) {
        this.items = items;
    }

    public getHash(): number {
        return (
            this.cachedHash ??
            (this.cachedHash = this.items.reduce((acc, current) => acc + getSimpleHashByString(current), 0))
        );
    }

    public isEquals(right: StringArrayKey): boolean {
        if (this.items.length != right.items.length) {
            return false;
        }
        return this.items.every((item, index) => item === right.items[index]);
    }
}
